<!-- Notification Toast Container: one polite live region, there before any toast, reads each one once -->
<div class="fixed top-4 right-4 z-[9999] space-y-3 max-w-md" aria-live="polite">
  <div
    *ngFor="let notification of notificationService.notifications()"
    [class]="
      'flex items-start gap-3 p-4 rounded-lg border shadow-lg transform transition-all duration-300 ease-in-out ' +
      style[notification.type].box
    "
  >
    <i aria-hidden="true" [class]="style[notification.type].icon + ' text-xl'"></i>
    <div class="flex-1 min-w-0">
      <h4 class="font-semibold text-sm">{{ notification.title }}</h4>
      <p class="text-sm mt-1 opacity-90 whitespace-pre-line">{{ notification.message }}</p>
    </div>
    <button
      type="button"
      [attr.aria-label]="translationService.t('common.close')"
      (click)="close(notification.id)"
      class="text-current opacity-50 hover:opacity-100 transition-opacity max-lg:-m-3 max-lg:grid max-lg:size-11 max-lg:shrink-0 max-lg:place-items-center"
    >
      <i class="fas fa-times"></i>
    </button>
  </div>
</div>

<!-- Confirmation Dialog: above every modal (highest z-[1200]) so a confirm asked from a
     modal is visible; below the toasts (z-[9999]). Its clicks stop here: a modal's
     click-outside handler on document must not read them as clicks outside it.
     Focus starts on Cancel, stays inside (a click on the backdrop too) and goes back on close; Escape cancels the
     confirm only, never the screen behind it. -->
<div
  *ngIf="notificationService.confirmDialog() as dialog"
  (click)="$event.stopPropagation()"
  (mousedown)="keepFocusInside($event)"
  (keydown.escape)="cancelOnEscape($event)"
  class="fixed inset-0 z-[9000] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
>
  <div
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="confirm-dialog-title"
    aria-describedby="confirm-dialog-message"
    tabindex="-1"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    class="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 outline-none"
  >
    <div class="p-6">
      <div class="flex items-start gap-4">
        <div
          [class]="
            'w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ' +
            (dialog.type === 'info' ? 'bg-gray-100' : 'bg-accent-50')
          "
        >
          <i aria-hidden="true" [class]="style[confirmKind(dialog.type)].icon + ' text-xl'"></i>
        </div>
        <div class="flex-1 min-w-0">
          <h3 id="confirm-dialog-title" class="text-lg font-semibold text-ink mb-2 break-words">
            {{ dialog.title }}
          </h3>
          <p id="confirm-dialog-message" class="text-sm text-ink-2 break-words">
            {{ dialog.message }}
          </p>
        </div>
      </div>
    </div>
    <div class="bg-gray-50 px-6 py-4 flex gap-3 justify-end rounded-b-lg">
      <button
        type="button"
        cdkFocusInitial
        (click)="notificationService.confirmNo()"
        class="px-4 py-2 max-lg:min-h-11 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-600 focus-visible:ring-offset-2"
      >
        {{ dialog.cancelText }}
      </button>
      <!-- Orange, like the shared confirmation dialog; a danger confirm (it cannot be undone) is red, the
           theme's one use of red, as the shared dialog's delete confirms are -->
      <button
        type="button"
        (click)="notificationService.confirmYes()"
        class="px-4 py-2 max-lg:min-h-11 text-sm font-medium rounded-lg transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-600 focus-visible:ring-offset-2"
        [ngClass]="
          dialog.type === 'danger'
            ? 'bg-red-600 text-white hover:bg-red-700'
            : 'text-black bg-accent hover:bg-accent-600'
        "
      >
        {{ dialog.confirmText }}
      </button>
    </div>
  </div>
</div>
